export default __webpack_public_path__ + "static/media/datingApp.589bf58d.png";